import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  breadcrumbs: {
    position: 'absolute',
    left: '30px',
    top: '23px',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '15px',
    zIndex: 30,
    color: '#2c2d3d',
    cursor: 'default',
  },
  container: {
    order: 1,
    background: '#EBECF4',
  },
  main: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 800,
    fontSize: '14px',
    color: 'rgba(44, 45, 62, 0.8)',
  },
  link: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 800,
    fontSize: '14px',
    color: '#3C419A',
  },
}));
